export default "__VITE_ASSET__BalOUhiK__"